import { render, staticRenderFns } from "./alterar-dados.vue?vue&type=template&id=9594f72a&"
import script from "./alterar-dados.vue?vue&type=script&lang=js&"
export * from "./alterar-dados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports